import React from 'react'
import { Callout, Box as List } from '@node-space/ui-components'

interface PayCalloutsContainers {
  calloutItems?: string[]
}

const PayCalloutsContainers = ({ calloutItems }: PayCalloutsContainers) => {
  return (
    <>
      {!!calloutItems?.length && (
        <Callout testId="pay-callouts" variant="info">
          {calloutItems?.length <= 1 && calloutItems?.[0]}
          <List tag="ul" paddingL={calloutItems?.length === 1 ? 4 : 12}>
            <ul
              className={`text-inherit text-body-regular-small list-outside ${calloutItems?.length === 1 ? 'list-none' : 'list-disc'}`}
            >
              {calloutItems?.map(message => <li key={message}>{message}</li>)}
            </ul>
          </List>
        </Callout>
      )}
    </>
  )
}

export default PayCalloutsContainers
